import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "flex flex-col items-center" }
const _hoisted_2 = { class: "w-full text-left" }
const _hoisted_3 = {
  key: 0,
  class: "text-black font-light text-xs leading-relaxed mb-6"
}
const _hoisted_4 = { class: "text-black font-light text-xs leading-relaxed whitespace-pre-line" }

import { useI18n } from 'vue-i18n';


export default /*@__PURE__*/_defineComponent({
  __name: 'infoModalStoneType',
  props: {
    value: { default: null }
  },
  setup(__props: any) {



const { t } = useI18n();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (__props.value)
        ? (_openBlock(), _createElementBlock("p", _hoisted_3, [
            _createTextVNode(_toDisplayString(_unref(t)('components.diamonds.details.stoneType.selected')) + ": ", 1),
            _createElementVNode("strong", null, [
              (__props.value === 'earth')
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createTextVNode(_toDisplayString(_unref(t)('components.diamonds.details.stoneType.earth')), 1)
                  ], 64))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createTextVNode(_toDisplayString(_unref(t)('components.diamonds.details.stoneType.lab')), 1)
                  ], 64))
            ])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("p", _hoisted_4, _toDisplayString(_unref(t)('components.diamonds.details.stoneType.text')), 1)
    ])
  ]))
}
}

})